const  createAdminReducer = (state = {}, action) => {
    switch (action.type) {
      case "CREATE_ADMIN": {
        return{
          ...state,
          createAdminSuccess: action.success
        }
      }
      case "CREATE_ADMIN_ERR": {
        return{
          ...state,
          createAdminError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default createAdminReducer;
  